import { render, staticRenderFns } from "./HomeOthers.vue?vue&type=template&id=188b5b46&"
import script from "./HomeOthers.vue?vue&type=script&lang=js&"
export * from "./HomeOthers.vue?vue&type=script&lang=js&"
import style0 from "./HomeOthers.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports